var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M7.81 14.437c-1.432-.205-2.621-.977-3.515-2.127-.89 1.35-1.918 2.823-3.086 4.417a.677.677 0 0 1-.93.151.643.643 0 0 1-.154-.91 105.08 105.08 0 0 0 3.394-4.893c-.592-1.17-.957-2.57-1.064-4.082C2.182 3.109 3.76 0 6.565.471c2.127.358 2.543 2.214 1.454 5.08-.565 1.488-1.547 3.339-2.947 5.556.615.942 1.422 1.617 2.375 1.913l-.268-1.624a.656.656 0 0 1 .111-.482l5.207-7.436a.641.641 0 0 1 .891-.168l3.117 2.182c.287.201.353.602.147.895l-5.207 7.436a.656.656 0 0 1-.415.27l-2.674.502a.624.624 0 0 1-.545-.158zm.968-1.226l1.782-.335 4.681-6.685-2.077-1.455-4.681 6.685.295 1.79zm7.207-8.082l1.488-2.125-2.078-1.455-1.487 2.125 2.077 1.455zm-3.488-1.651L14.729.29a.641.641 0 0 1 .89-.168l3.117 2.182c.287.201.353.602.148.895l-2.232 3.187a.641.641 0 0 1-.891.168l-3.117-2.183a.641.641 0 0 1-.147-.894zm-5.728 1.62c.84-2.213.627-3.163-.43-3.341-1.632-.274-2.776 1.98-2.553 5.146.072 1.023.275 1.975.59 2.813 1.122-1.832 1.92-3.373 2.393-4.619z", id: "svg232561283a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(0 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg232561283b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg232561283a" })
      ),
      React.createElement("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#svg232561283a" }),
      React.createElement(
        "g",
        { mask: "url(#svg232561283b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1-2h21v21H-1z" })
      )
    )
  );
});